import appStoreDE from './app-store-de.png';
import appStoreEN from './app-store-en.png';
import googlePlayDE from './google-play-de.png';
import googlePlayEN from './google-play-en.png';
import footerCloud from './footer-cloud.png';
import footerLogoM from './footer-logo-m.png';
import footerLogo from './footer-logo.png';
import footerSite from './footer-site.png';
import appStorePcDE from './app-store-pc-de.png';
import appStorePcEN from './app-store-pc-en.png';
import googlePlayPcDE from './google-play-pc-de.png';
import googlePlayPcEN from './google-play-pc-en.png';
import cloudWebEn from './cloud-web-en.png';

export default {
    appStoreDE,
    appStoreEN,
    googlePlayDE,
    googlePlayEN,
    appStorePcDE,
    appStorePcEN,
    googlePlayPcDE,
    googlePlayPcEN,
    cloudWebEn,
    footerCloud,
    footerLogo,
    footerLogoM,
    footerSite
};
